import { Component, ViewChild } from '@angular/core';
import { ModalComponent } from '../../core-components/modal/modal.component';
import { Observable } from 'rxjs';
import { AtlasTranslateService } from '../../translate/translate.service';

@Component({
  selector: 'atlas-user-required-modal',
  templateUrl: './user-required.modal.component.html',
  styleUrls: ['./user-required.scss']
})
export class UserRequiredModalComponent {
  @ViewChild('modal', { static: true }) modal: ModalComponent;

  title$: Observable<string>;
  description$: Observable<string>;
  button$: Observable<string>;

  constructor(
    private atlasTranslateService: AtlasTranslateService
  ) {
    this.title$ = this.atlasTranslateService.stream('USER_REQUIRED_MODAL.TITLE', 'Account user required');
    this.description$ = this.atlasTranslateService.stream(
      'USER_REQUIRED_MODAL.DESCRIPTION',
      'You must be a user on this account to continue. Administrators may create or impersonate a user on this account to access this page.'
    );
    this.button$ = this.atlasTranslateService.stream('COMMON.ACTION_LABELS.CLOSE', 'Close');
  }

  closeModal(): void {
    this.modal.closeModal();
  }
}
